import propTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { visitSearch } from 'app/Router/actions';
import { deletePageThunk } from 'app/Tree/thunks';
import favoriteComponentsSelector from 'app/UserInfo/selectors/favoriteComponents';
import { populateIsFavoriteComponent } from 'utils/factory';
import connect from 'utils/store/connect';

import Search from './components/Search';
import makeFiltersSelector from './selectors/makeFilters';
import makePageNumStartSelector from './selectors/makePageNumStart';
import makeResultsSelector from './selectors/makeResults';
import makeSuggestionsSelector from './selectors/makeSuggestions';
import makeSuggestionsLoadingSelector from './selectors/makeSuggestionsLoading';
import makeResultsLoadingSelector from './selectors/makeResultsLoading';
import makeCurrPageNumSelector from './selectors/makeCurrPageNum';
import {
  addFilter,
  deleteFilter,
  getSearchResults,
  getSearchSuggestions,
  storeResultPageNum
} from './thunks';

/**
 * make a mapStateToProps function
 * @returns {Function} a mapStateToProps function
 */
const makeMapState = function makeMapStateToProps() {
  const currPageNumSelector = makeCurrPageNumSelector();
  const filtersSelector = makeFiltersSelector();
  const resultsLoadingSelector = makeResultsLoadingSelector();
  const resultsSelector = makeResultsSelector();
  const suggestionsLoadingSelector = makeSuggestionsLoadingSelector();
  const suggestionsSelector = makeSuggestionsSelector();
  const pageNumStartSelector = makePageNumStartSelector();

  /**
   * map redux state to react component properties
   * @param {object} state - redux state object
   * @param {object} props - props passed to the container
   * @returns {object} react props
   */
  return function mapStateToProps(state, props) {
    const { context } = props;
    return {
      currPageNum: currPageNumSelector(state, props),
      context,
      filters: filtersSelector(state, props),
      pageNumStart: pageNumStartSelector(state, props),
      results: populateIsFavoriteComponent(
        resultsSelector(state, props),
        favoriteComponentsSelector(state)
      ),
      resultsLoading: resultsLoadingSelector(state, props),
      suggestions: suggestionsSelector(state, props),
      suggestionsLoading: suggestionsLoadingSelector(state, props)
    };
  };
};

/**
 * map action creators to react component properties
 * @param {Function} dispatch - redux dispatch function
 * @param {object} props - props passed to the container
 * @returns {object} react props
 */
const mapDispatch = function mapDispatchToProps(dispatch, props) {
  // wrap search-related action creators with the context
  const { context } = props;
  const actionsWithContext = {
    addFilter: (...args) => addFilter(context, ...args),
    context,
    deleteFilter: (...args) => deleteFilter(context, ...args),
    getSearchResults: (...args) => getSearchResults(context, ...args),
    getSearchSuggestions: (...args) => getSearchSuggestions(context, ...args),
    storeResultPageNum: (...args) => storeResultPageNum(context, ...args)
  };
  const bindables = {
    ...actionsWithContext,
    deletePageThunk,
    getSearchResults,
    visitSearch
  };
  return bindActionCreators(bindables, dispatch);
};

const container = connect(makeMapState, mapDispatch)(Search);

container.propTypes = {
  context: propTypes.string.isRequired
};

export default container;
